'use strict';

import { Entity } from '../Entity';
import { App } from '../App';

export class UserAppWebhook extends Entity {
  protected id;

  protected app;

  //protected user;

  protected name;

  protected url;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.url = data.url;

    if (data.app) {
      const app = new App();

      app.hydrate(data.app);

      this.app = app;
    }
  }

  public getId() {
    return this.id;
  }

  public getApp() {
    return this.app;
  }

  public getName() {
    return this.name;
  }

  public getUrl() {
    return this.url;
  }
}
